import {Gender} from "@/choices";
import dayjs from "dayjs";

export function isStandardBirthNumber(value) {
    const number = parseInt(value.replace('/', ''));
    return number % 11 === 0 && value.length >= 9

}

export function convertBirthDateToNumber(gender, birthDate) {
    if (typeof (birthDate) === "string") {
        birthDate = new dayjs(birthDate)
    }
    let date = birthDate.date()
    let month = birthDate.month() + 1
    let year = birthDate.year()
    if (gender === Gender.FEMALE) {
        month = month + 5
    }
    return year.toString().slice(2) + ('0' + month).slice(-2) + ('0' + date).slice(-2)

}

export function convertBirthNumberToDate(gender, birthNumber) {
    let date = parseInt(birthNumber.slice(4, 6))
    let month = parseInt(birthNumber.slice(2, 4)) - 1
    if ((1 <= date && date <= 31) && (0 <= month && month <= 11)) {
        let year = birthNumber.slice(0, 2)
        if (gender === Gender.FEMALE) {
            month = month - 5
        }
        let thisYear = new dayjs().year()
        let patientBirthYear = parseInt(thisYear.toString().slice(0, 2) + year)
        while (true) {
            if (patientBirthYear <= thisYear) {
                const suggestedDate = new dayjs(new Date(patientBirthYear, month, date))
                if (suggestedDate.isValid()) {
                    debugger
                    return suggestedDate
                }
                return null
            }
            patientBirthYear = patientBirthYear - 100
        }
    }
    return null
}